<template>
    <div class="topcode-wechat-device-item" @click="updateShow">
        <div class="top">
            <div :class="'flex-center-y auto-width-8 state  device-state-'+childDevice.deviceState">{{childDeviceStateDICT}}</div>
            <div class="flex-center-y time ">{{childDevice.heartBeatTime}}</div>
        </div>
        <div class="body">
            <div class="left">
                <div class="flex-center-y center">
                    <img :src="downloadImg + childDevice.productImage1"/>
                    <div class="name" style="font-size: 14px">
                        <div class="title-small">{{childDevice.name}}</div>
                        <div>{{childDevice.productName}}</div>
                    </div>
                </div>
            </div>
            <div class="flex-center right">
                编辑<van-icon name="arrow"/>
            </div>
        </div>
        <div class="footer">
            <div class="row" style="font-size: 14px"><label>设备编号</label> <span>{{childDevice.sn}}</span></div>
            <div class="row" style="font-size: 14px"><label>所属单位</label> <span>{{childDevice.unitName}}</span></div>
            <div class="row" style="font-size: 14px"><label>所属区域</label> <span>{{childDevice.areaName}}</span></div>
            <div class="row" style="font-size: 14px"><label>安装位置</label> <span>{{childDevice.installLocation}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import UploadImage from "@/components/UploadImage";
    import {Dialog } from "vant";
    import * as DICT from "@/utils/dict"
    import {downloadImg} from "@/config"

    export default {
        components: {
            UploadImage,
            Dialog
        },
        props: {
            childDevice: {type: Object, required: true}
        },
        data() {
            return {
                downloadImg
            };
        },
        computed: {
            childDeviceStateDICT() {
                return DICT.getValue('DEVICE_STATE_TYPE', this.childDevice.deviceState)
            }
        },
        created() {
        },
        mounted() {

        },
        methods: {
            updateShow() {
                //this.show = true;
                this.$emit('onUpdate',this.childDevice)
            },
        },
        watch: {}
    };
</script>

<style lang="less" scoped>
    .topcode-wechat-device-item {
        width: 100%;
        /*height: 225px;*/
        padding-bottom: 3px;
        margin-bottom: 8px;
        border-radius: 8px;
        border: 1px #cccccc solid;
        /*background: #51c332;*/

        & > .top {
            color: #fff;
            display: flex;
            height: 28px;
            border-radius: 8px 8px 0px 0px;
            background: #7e7e7e;
            & > .state {
                height: 100%;
                justify-content: center;
                /*width: 60px;*/
                border-radius: 8px 0px 0px 0px;
            }
            & > .time {
                height: 100%;
                width: 100%;
                padding-right: 5px;
                justify-content: flex-end;

            }
        }
        & > .body {
            display: flex;
            & > .left {
                padding: 8px;
                width: 100%;
                & > .center {
                    /*padding: 5px;*/
                    display: flex;
                    /*background: #5cd8bc;*/
                    & > img {
                        width: 60px;
                        height: 60px;
                        background: #cccccc;
                    }
                    & > .name {
                        padding-left: 20px;
                        height: 100%;
                        display: flex;
                        /*background: #7e7e7e;*/
                        flex-direction: column;

                        & > div {
                            line-height: 1.5;

                        }
                    }
                }
            }
            & > .right {
                width: 75px;
                color: #fa7d2d;
                font-size: 14px;
                font-weight: 500;
            }
        }
        & >.footer{
            padding-left: 15px;
            & > .row {
                display: flex;
                line-height: 1.5;
                /*align-items: center;*/
                & > label {
                    width: 75px;
                    flex-shrink: 0;
                    &::after {
                        margin-left: 2px;
                        content: '：';
                    }
                }
                & > span {
                }
            }
        }
    }
</style>
